<template>
	<div class="modal-popup">
		<div class="modal-close" @click="onClose">
			&times;
		</div>
		<div class="modal-content">
			<div>
				<h1 class="text-primary">
					{{ $tc('modals.cameraSupport.title') }}
				</h1>
				<h3 class="text-primary">
					{{ options.title }}
				</h3>
			</div>
			<div class="mt-25 mb-35">
				<p v-html="options.description" />
			</div>
			<div class="mt-75 flex justify-end">
				<button
					:title="$tc('actions.confirm')"
					class="text-truncate button-light-blue"
					@click="onConfirm"
				>
					{{ $tc('actions.confirm') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalCameraSupport',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>
